var _path, _rect, _rect2, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 101,
    viewBox: "0 0 94 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1304 7H36.8551M65.7681 7H74C78.4183 7 82 10.5817 82 15V80C82 84.4183 78.4183 88 74 88H20C15.5817 88 12 84.4183 12 80V15C12 10.5817 15.5817 7 20 7H27.2174",
    stroke: "#000",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.2029,
    y: 1,
    width: 9.64461,
    height: 13.3043,
    rx: 4.82231,
    stroke: "#000",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.3143,
    y: 1,
    width: 9.64461,
    height: 13.3043,
    rx: 4.82231,
    stroke: "#000",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 27L82 27",
    stroke: "#000",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 46V74.358C12 78.7762 15.5817 82.358 20 82.358H74C78.4183 82.358 82 78.7762 82 74.358V46",
    stroke: "#000",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.132 62C5.19423 66.0272 1 71.2695 1 77.0015C1 89.7032 21.5949 100 47 100C72.4051 100 93 89.7032 93 77.0015C93 71.2948 88.8428 66.0736 81.96 62.0536",
    stroke: "#000",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 35,
    width: 10,
    height: 10,
    stroke: "#000",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 35,
    width: 10,
    height: 10,
    stroke: "#000",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 35,
    width: 10,
    height: 10,
    stroke: "#000",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 57,
    width: 10,
    height: 10,
    stroke: "#000",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 57,
    width: 10,
    height: 10,
    stroke: "#000",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 57,
    width: 10,
    height: 10,
    stroke: "#000",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarImage);
export default __webpack_public_path__ + "static/media/calendarImage.45d47ba9ba353dc02c453c5df2e1c237.svg";
export { ForwardRef as ReactComponent };